type Name = string | undefined;

export const trimName = (firstName: Name, lastName: Name): string => {
  return `${firstName ? firstName.trim() : ""} ${
    lastName ? lastName.trim() : ""
  }`.trim();
};
